<template>
  <div class="header">
    <h1>來信列表</h1>
    <div class="d-flex align-items-center col-9 justify-content-end">
    </div>
  </div>
  <div class="filter">
    <div class="d-flex" style="gap:20px">
      <div>
        <el-date-picker
          v-model="filterData.filterDate"
          type="daterange"
          range-separator="至"
          start-placeholder="開始時間"
          end-placeholder="結束時間"
          size="large"
          @change="isDateDisabled"
        />
      </div>
      <div class="position-relative d-flex align-items-center col-8">
        <CFormInput
          class="rounded-pill pe-5"
          type="text"
          placeholder="請輸入用戶帳號、電話號碼或信箱等相關資訊"
          v-model="filterData.filterName"
          style="font-size: 15px;"
        />
        <!-- <img
          class="position-absolute search"
          src="@/assets/icons/search.svg"
          alt=""
        /> -->
      </div>
    </div>
    <div class="filter-buttons">
      <button class="rounded-pill" @click="resetFilter">重置</button>
      <button class="rounded-pill" style="background: #177baf;color: #fff;border:none;" @click="getList">搜尋</button>
    </div>
  </div>
  <CRow class="my-5 fw-bold col-12 mx-auto list-title">
    <CCol xs="2" class="text-center">日期</CCol>
    <CCol xs="2" class="text-center">帳號</CCol>
    <CCol xs="2" class="text-center text-nowrap">電話</CCol>
    <CCol xs="3" class="text-center text-nowrap">信箱</CCol>
    <CCol xs="2" class="text-center text-nowrap">類型</CCol>
    <CCol xs="1" class="text-center text-nowrap"> </CCol>
  </CRow>
  <CRow
    v-for="item in messageList"
    :key="item.name"
    class="mb-4 py-4 border list d-flex align-items-center col-12 mx-auto"
  >
    <CRow style="width: 100%;">
      <CCol xs="2" class="text-center">{{ formatTimestamp(item.created) }}</CCol>
      <CCol xs="2" class="text-center">{{ item.name }}</CCol>
      <CCol xs="2" class="text-center">{{ item.phone }}</CCol>
      <CCol xs="3" class="text-center">{{ item.email }}</CCol>
      <CCol xs="2" class="text-center" style="font-size:12px;">{{ item.category }}</CCol>
      <CCol xs="1" class="d-flex align-items-center justify-content-around">
        <CButton
          v-if="isButtonShow('user/contact-delete')"
          color="light"
          class="list-btn text-nowrap"
          @click="deleteQue(item.id)"
        >
          刪除
          <img src="@/assets/icons/delete.svg" alt="" />
        </CButton>
      </CCol>
    </CRow>
    <CRow>
      <CCol xs="12" class="content">
        內容：<br/>{{item.content}}
      </CCol>
    </CRow>
  </CRow>
  <div class="d-flex align-items-center justify-content-center py-4">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pagination.totalCount"
      :page-size="pagination.pageSize"
      @current-change="changePage"
    />
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import router from '@/router'
import useInfo from '@/composables/useInfo'
import MsgBox from '@/components/MsgBox.vue'
import { ref, computed } from '@vue/reactivity'
import { formatDateFullToMinute } from '@/utils/format-date.js'
import MessageBox from '@/plugins/MessageBox'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import { useStore } from 'vuex'
export default {
  components: {
    MsgBox,
  },
  setup() {
    const { getMessageList, messageDelete } = useInfo()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const messageList = ref([])
    const store = useStore()
    const filterData = ref({
      filterName: '',
      filterDate: []
    })
    const pagination = ref({})
    const currentPage = ref(1)
    const getList = async () => {
      manualToggleLoading(true)
      const res = await getMessageList({
        begin_at: filterData.value.filterDate.length ? dateRangeTimestanp.value[0] : null,
        end_at: filterData.value.filterDate.length ? dateRangeTimestanp.value[1] : null,
        condition: filterData.value.filterName,
      })
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        messageList.value = res.ret.data
        messageList.value.sort((a,b)=>b.created - a.created)
        pagination.value = res.ret.pagination
        manualToggleLoading(false)
      }
    }
    getList()
    const changePage = async (page) => {
      currentPage.value = page
      const res = await getMessageList({ 
        begin_at: dateRangeTimestanp.value[0],
        end_at: dateRangeTimestanp.value[1],
        condition: filterData.value.filterName,
        page: currentPage.value 
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        messageList.value = res.ret.data
        messageList.value.sort((a,b)=>b.created - a.created)
        pagination.value = res.ret.pagination
      }
      document.scrollingElement.scrollTop = 0
    }
    const resetFilter = async ()=>{
      filterData.value = {
      filterName: '',
      filterDate: []
      }
      await getList()
    }
    const isButtonShow = (key)=>{
      if(store.state.userInfo.auth_data === true){
        return true
      }else{
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const dateRangeTimestanp = computed(()=>{
      let date = filterData.value.filterDate.map(element => {
        return new Date(element).getTime() / 1000
      });
      date[1] += 86400
      return date
    })
    const isDateDisabled = ()=>{
      const selectDate = filterData.value.filterDate[0] = new Date(filterData.value.filterDate[0]).getTime()
      const today = new Date().getTime()
      if(selectDate > today){
        showMsgBox.value = true
        errorMsg.value = '開始日期不得大於今天'
        filterData.value.filterDate = []
      }
      
    }
    const formatTimestamp = (timestamp) => {
      return formatDateFullToMinute(timestamp * 1000)
    }
    const deleteQue = async (id) => {
      MessageBox({
        message: '刪除後無法復原，您確定要刪除此訊息？',
        onConfirm: async () => {
          const res = await messageDelete({ id: id })
          if (!res.error) {
            location.reload()
          } else {
            showMsgBox.value = true
            errorMsg.value = res.msg
            errorCode.value = res.error
          }
        },
      })
    }
    const toPreview = (info) => {
      const routeData = router.resolve({
        path: `/preview/${info?.id}/${info?.subjects_info[0].part_id}`,
      })
      window.open(routeData.href, '_blank')
    }

    return {
      messageList,
      formatTimestamp,
      showMsgBox,
      errorMsg,
      errorCode,
      deleteQue,
      toPreview,
      isButtonShow,
      filterData,
      changePage,
      currentPage,
      pagination,
      dateRangeTimestanp,
      getList,
      resetFilter,
      isDateDisabled
    }
  },
}
</script>
<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1%;
  box-shadow: rgb(69 69 69 / 15%) 0px 1px 4px 0px;
  margin: 0 0 10px 0;
  img {
    width: 100px;
  }
}
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}
h3 {
  font-size: 22px;
  margin: 0 20px 0;
}
.que-btn {
  height: 150px;
  box-shadow: 0 1px 4px 0 rgb(69 69 69 / 20%), 0 1px 2px 0 rgb(69 69 69 / 10%);
  border-radius: 4px;
}
.list-title {
  font-size: 14px;
}
.list {
  min-height: 48px;
  border-radius: 20px;
}
.filter {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.filter-buttons{
  display: flex;
  gap: 10px;
  button{
    background: transparent;
    border: 1px solid #eee;
    width: 100px;
    border:1px solid var(--cui-input-border-color, #b1b7c1);
    color: rgba(0, 0, 0, 0.6);
    font-size: 15px;
  }
}
.search {
  right: 16px;
}
.state {
  border-radius: 4px;
  color: #fff;
  width: 64px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
}
.result {
  font-size: 12px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  white-space: nowrap;
}
.list-btn {
  font-size: 12px;
  display: flex;
  align-items: center;
  width: 64px;
  height: 24px;
  img {
    width: 16px;
    margin-left: 5px;
  }
}
.list-tips {
  cursor: no-drop;
}
.add-que {
  background: #d1e5ef;
  border-radius: 20px;
  height: 50px;
}
.content{
  margin-top:20px;
  padding: 20px 10px 0 50px;
  border-top:1px solid rgba(0, 0, 0, 0.3);
  word-wrap: break-word;
  white-space: pre-line;
}
</style>
